var map = {
	"./assistant.js": "718c",
	"./auth.js": "2f00",
	"./environment.js": "0926",
	"./game.js": "1129",
	"./index.js": "feb9",
	"./payment.js": "ad54",
	"./request.js": "2925",
	"./user.js": "45da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0dc8";